export const RECOMMENDED_BOOKS = "RECOMMENDED_BOOKS";
